import { render, staticRenderFns } from "./quesSkin.vue?vue&type=template&id=cda2efe0&"
import script from "./quesSkin.vue?vue&type=script&lang=js&"
export * from "./quesSkin.vue?vue&type=script&lang=js&"
import style0 from "./quesSkin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports